;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.Player = Backbone.Model.extend({
		defaults: {
			id: 0,
			first_name: '',
			last_name: '',
			is_visible: true,
			is_favourite: false,
			rulesFormat: {
				cost: {
					sorted_field: true,
					to_fixed: 0
				},
				dollar_points: {
					sorted_field: true,
					to_fixed: 0
				},
				stats_avg_points: {
					to_fixed: 1
				},
				stats_owned_by: {
					to_fixed: 1
				},
				stats_last_3_avg: {
					to_fixed: 1
				},
				stats_total_points: {
					to_fixed: 1
				},
				last_points: {
					to_fixed: 1
				}

			}
		},

		initialize: function() {
			this.initializeCalculatedAttributes();

			// TODO: Event can be removed if not needed
			this.on('change:cost', this.initializeCalculatedAttributes, this);
			this.on('change:stats', this.initializeCalculatedAttributes, this);
		},

		initializeCalculatedAttributes: function() {
			var cost = this.get('cost'),
				prices = _.propertyOf(this.get('stats'))('prices'),
				keys_number = _.keys(prices).map(function(item) {
					return parseInt(item, 10);
				}),
				last_price_key = _.max(keys_number),
				season_change = cost - _.propertyOf(prices)('1'),
				round_change = _.propertyOf(prices)(last_price_key) - _.propertyOf(prices)(last_price_key - 1);

			this.set({
				season_change: isNaN(season_change) ? 0 : season_change,
				round_change: isNaN(round_change) ? 0 : round_change
			}, { silent: true });

			return this;
		},

		url: function() {
			return this.methodUrl;
		},

		isNew: function() {
			return true;
		},

		toggleFavouritePlayer: function() {
			var is_favourite = this.get('is_favourite');

			this.set('is_favourite', !is_favourite);

			this
				.clone()
				.clear()
				.setApiUrl(is_favourite ? 'favourite_player/delete' : 'favourite_player/add')
				.save({ player_id: this.get('id') }, {
					ajaxSync: true,
					success: _.bind(function(model, resp) {
						if (resp.success!=1) {
							//TODO:S add errors checking
							this.set('is_favourite', is_favourite);
						}
					}, this)
				});

			return this;
		},

		getOppositions: function(round) {

			let
				player_squad = this.get('squad_id'),
				is_bye = ~round.get('bye_squads').indexOf(player_squad),
				player_squad_name = round.get('squad_names')[player_squad].short_name,
				html = '<span><em>' + player_squad_name + '</em></span>',
				player_match
			;

			if (is_bye) {
				html = '<span><em>BYE</em></span>'
			}
			else {
				_.find(round.get('matches'), function(match) {
					let away_squad = round.get('squad_names')[match.away_squad_id],
						home_squad = round.get('squad_names')[match.home_squad_id],
						away = away_squad.short_name,
						home = home_squad.short_name;

					if (match.home_squad_id==player_squad) {
						player_match = match;
						html = '<span><em>' + home + '</em> vs ' + away + '</span>';

						return match.status=='scheduled';
					}

					if (match.away_squad_id==player_squad) {
						player_match = match;
						html = '<span>' + home + ' vs <em>' + away + '</em></span>';

						return match.status=='scheduled';
					}
					return false;
				});
			}

			this.set('opposition', html);
			this.set('match', player_match);

			return this;
		},

		setBlocked: function() {

			if (this.get('match').status!=='scheduled') {
				this.set('is_blocked', true);
			}

			return this;
		},

		blockByLocked() {
			if (this.get('locked')==1) {
				this.set('is_blocked', true);
			}
			return this;
		},

		isInName: function(find_value) {
			var
				full_name = (this.get('first_name') + this.get('last_name')).toLowerCase(),
				entered_name = find_value.toLowerCase()
			;

			return find_value.length ? Boolean(~full_name.indexOf(entered_name)) : true;
		},
		isInSquad: function(squad_id) {
			return squad_id ? (+this.get('squad_id'))===(+squad_id) : true;
		},
		isPosition: function(position) {
			return position ? Boolean(~this.get('positions').indexOf(+position)) : true;
		},
		isDPP: function(is_should_be_filtered) {
			return is_should_be_filtered ? this.get('positions').length > 1 : true;
		},
		isFavorite: function(is_should_be_filtered) {
			return is_should_be_filtered ? this.get('is_favourite') : true;
		},
		isAvailable: function(is_should_be_filtered) {
			var stats = ['playing', 'uncertain'];
			return is_should_be_filtered ? Boolean(~stats.indexOf(this.get('status'))) : true;
		},
		isNotAvailable: function(is_should_be_filtered) {
			var stats = ['injured', 'not-playing', 'is_bye'];
			return is_should_be_filtered ? Boolean(~stats.indexOf(this.get('status'))) : true;
		},
		isInCost: function(cost, remaining_salary) {

			if (!cost) {
				return true;
			}

			var price = cost.split('-'),
				player_cost = this.get('cost'),
				min,
				max;

			if (!Boolean(price[1])) {
				return Boolean(player_cost <= remaining_salary);
			}

			min = +price[0] * 1000;
			max = +price[1] * 1000;

			return Boolean(player_cost >= min && player_cost <= max);
		},

		removeEmpty: function(val) {
			return val;
		},

		getRoundsFixtures: function(rounds) {
			let round_fixtures = [];

			rounds.each(round => {
				let fixtures = this.getRoundOpponent(round);

				if (fixtures.length) {

					_.each(fixtures, fixture => {
						round_fixtures.push({
							fixture:  fixture,
							round_id: fixture.round_id,
							match_id: fixture.match_id,
							side:     fixture.side
						})

					});
				}

			});
			return round_fixtures;

		},

		getFixtureMatchData: function(match, key) {

			return {
				side: key,
				round_id: match.round,
				match_id: match.id,
				status: match.status,
				venue_id: match.venue_id,
				venue_name: match.venue_name,
				squad_id: match[key + '_squad_id'],
				squad_name: match[key + '_squad_name']
			}

		},

		getRoundOpponent: function(round) {

			var player_squad_id = this.get('squad_id');

			function comparator(match) {

				if (match.home_squad_id===player_squad_id) {
					return this.getFixtureMatchData(match, 'away');
				}

				if (match.away_squad_id===player_squad_id) {
					return this.getFixtureMatchData(match, 'home');
				}

			}

			return round.get('matches') ? round.get('matches').map(_.bind(comparator, this)).filter(this.removeEmpty) : {};

		},

		getMatchPoints(round, match_id){
			return this.setPointsLastRound(round, match_id).get('last_points');
		},

		getTotalPoints(fixture){
			return fixture.total_points ? fixture.total_points : 0;
		},

		setMatchStats: function(stats, rounds) {

			if (this.get('match_stats')) {
				return this;
			}

			var fixtures = this.getRoundsFixtures(rounds),
				total_scores = {},
				total_points = 0,
				player = $.extend(true, {}, this);

			// TODO: Split this!!!
			_.each(fixtures, function(fixture) {

				fixture.scores = undefined;
				let round_id = fixture.round_id,
					match_id = fixture.match_id,
					round = rounds.get(round_id),
					searched_stats = stats.find({ match_id }) || stats.find({ round_id })
				;

				if (searched_stats) {
					fixture.scores = searched_stats.getCalculatedPlayerScores(player);
				}

				if (fixture.scores) {
					fixture.total_points = _.chain(fixture.scores)
						.pluck('points')
						.reduce(function(memory, value) {
							return memory + value;
						}, 0)
						.value();
				}

				fixture.match_points = this.getMatchPoints(round, match_id);

				total_points += this.getTotalPoints(fixture);

				_.each(fixture.scores, function(value, key) {

					if (!total_scores[key]) {
						total_scores[key] = _.extend({}, value);
					} else {
						total_scores[key].points = total_scores[key].points + value.points;
						total_scores[key].value = total_scores[key].value + value.value;
					}
				});

				return this;

			}, this);

			fixtures.push({
				round_id: 'all',
				scores: _.keys(total_scores).length ? total_scores : undefined,
				total_points: total_points
			});

			this.set('match_stats', fixtures);

			return this;

		},

		isPlaying: function(is_playing) {

			this.set('is_playing', is_playing);

			return this;
		},

		getValueByKeys: function(player, searched_keys) {

			var keys = searched_keys.split('.'),
				val = player.get(keys.shift());

			_.each(keys, function(key) {
				val = val[key];
			});

			if (typeof val==="string" || val instanceof String) {
				val = val.toLocaleLowerCase();
			}

			return val;
		},

		setPointsLastRound: function(round, match_id) {
			let squads_obj = {},
				round_id = round.get('id');

			let matches = round.get('matches'),
				squad_id = this.get('squad_id'),

				isPlayerPlayed = _.bind(function() {
					var matches_len = matches.length,
						player_match = {};

					if (squads_obj[squad_id]) {
						player_match = squads_obj[squad_id];
					}

					if (!player_match.id) {
						while (matches_len--) {
							var match = matches[matches_len];
							if (squad_id==match.away_squad_id || squad_id==match.home_squad_id) {
								squads_obj[squad_id] = match;
								player_match = match;
								break;
							}
						}
					}

					this.set({ is_player_bye: !player_match.id });

					this.isPlaying(player_match.status && player_match.status!='complete' && player_match.status!='scheduled');

					return player_match.status && player_match.status!='complete';
				}, this),

				is_played = isPlayerPlayed(),
				points_last_round = is_played ? '-' : 'DNP',
				match_points = match_id && this.get('stats').hasOwnProperty('match_scores') && this.getValueByKeys(this, 'stats.match_scores.' + match_id, true),
				player_last_round = _.isUndefined(match_points) ? this.getValueByKeys(this, 'stats.scores.' + round_id, true) : match_points ;
			if (this.get('is_player_bye')) {
				points_last_round = 'BYE';
			}

			else if (player_last_round || player_last_round==0) {
				points_last_round = player_last_round;
			}

			this.set({
				is_played: is_played,
				last_points: points_last_round,
				match_points
			});

			return this;
		},

		removeIfTransferred() {
			if (this.get('status')==='transferred') {
				this.set('is_visible', false);
			}

			return this;

		}

	});

}(window, APP, Backbone, Marionette, $, _));
